import { Component, namespace } from 'nuxt-property-decorator'
import ExperienceBreadcrumb from '~/components/experience/experience-base/experience-breadcrumb'

const experience = namespace('experience')

@Component
export default class ExperienceSeo extends ExperienceBreadcrumb {
  @experience.State countryId!: number
  @experience.State cityId!: number
  @experience.State destinationTitle!: string
  @experience.State categoryTitle!: string


  getCommonHead() {
    /**
     * 因为mobile没有上线，需要先屏蔽所有的seo收录
     * 先保留注释，等mobile上线再打开
     */

    const bannerImage = 'https://res.klook.com/image/upload/activities/ecdfm0jymrc7kncq4gp8.jpg'
    const path = this.$route.path
    const $setMeta = this.$setMeta.bind(this)

    // seo-cn link
    const link = this.$canonical({ indexable: true })

    // Title tag
    // Top {experiences} in {destination} - Find weekend, family and popular {experiences} in {destination} - Klook
    const title = this.$t('16829', {
      experiences: this.categoryTitle,
      destination: this.destinationTitle
    })
    const description = this.$t('16830', { destination: this.destinationTitle })
    const keywords = this.$t('16830', { destination: this.destinationTitle })

    // og tags
    const ogMetas = [
      $setMeta({ property: 'og:locale', content: this.$i18n.locale }),
      $setMeta({ property: 'og:type', content: 'product.group' }),
      $setMeta({ property: 'og:title', content: title }),
      $setMeta({ property: 'og:description', content: description }),
      $setMeta({ property: 'og:url', content: this.$href(path) }),
      $setMeta({ property: 'og:image', content: bannerImage }),
      $setMeta({ property: 'og:site_name', content: this.$t('seo.site.name').toString() }, true)
    ]

    // Twitter Tags
    const twitterTag = [
      $setMeta({ name: 'twitter:title', content: title }),
      $setMeta({ name: 'twitter:description', content: description }),
      $setMeta({ name: 'twitter:site', content: '@KlookTravel' }),
      $setMeta({ name: 'twitter:image', content: bannerImage })
    ]

    const breadcrumbList = this.getBreadcrumb()
    // breadcrumb
    const breadcrumb = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbList.map((v, index) => this.getListItem(index + 1, v.deeplink, v.name))
    }

    return {
      title,
      link,
      meta: [
        this.$description(description),
        this.$keywords(keywords),
        ...ogMetas,
        ...twitterTag
      ],
      script: [this.$ldjson(breadcrumb)]
    }
  }

  getListItem(position: number, id: string, name: string) {
    return {
      '@type': 'ListItem',
      position,
      item: {
        '@id': id,
        name
      }
    }
  }
}
